
import { Vue, Component, Prop } from "vue-property-decorator";
import { Image as VanImage } from "vant";
@Component({
  components: {
    "van-image": VanImage
  }
})
export default class index extends Vue {
  @Prop()
  info: any;

  defaultPlaceholder = require("@/assets/kaizhou-shuai-video/4-3@2x.png");
}
